<template>
    <div :class="[$prefixClass.card + '-stroke quick-action-box', box.new ? 'active' : '']">
        <!-- <div v-if="box.new" class="quick-action-box__new"></div> -->
        <div class="display-space-between">
            <img class="m-b-10" :src="require(`./../assets/icons/${box.icon}`)" alt=""/>
            <a-badge :class="['quick-action-box__badge', box.status]">{{ $t(`dashboard.quick_actions.status.${box.status}`) }}</a-badge>
        </div>
        <h4 class="m-b-10"> {{ $t(`dashboard.quick_actions.${box.type}.title`) }}</h4>
        <div :class="$prefixClass.row" v-if="box.type === 'optimize'">
            <div :class="$prefixClass.col + '-14'">
                <h6 :class="[box.imageFound > maximumImagePopup ? 'danger-color' : (box.imageFound > maximumImageInApp ? 'warning-color' : 'success-color'), 'm-0']" v-html="box.imageFound"></h6>
                <span class="text-color-secondary fz-14">Images found</span>
            </div>
            <div :class="$prefixClass.col + '-10'">
                <h6 :class="[box.fileFound > maximumThemePopup ? 'danger-color' : (box.fileFound > maximumThemeInApp ? 'warning-color' : 'success-color'), 'm-0']" v-html="box.fileFound"></h6>
                <span class="text-color-secondary fz-14">File found</span>
            </div>
        </div>
        <div class="fz-14 text-color-secondary" v-else v-html="$t(`dashboard.quick_actions.${box.type}.${box.status}`)"></div>
        <a-button :type="secondaryBtns.includes(box.status) ? 'secondary' : 'primary'"
            :disabled="box.status === 'optimizing'"
            @click="handleAction(box)"
        >
            <template v-if="box.status == 'optimizing'">
                <i class="far fa-spinner fa-pulse"></i>
            </template>
            <template v-else>
                {{ $t(`dashboard.quick_actions.${box.type}.buttons.${box.status}`) }}
            </template>
        </a-button>
    </div>
</template>
<script>
export default {
    name: 'QuickActionBox',
    props: {
        box: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            secondaryBtns: ['active', 'optimized', 'basic', 'smart']
        }
    },
    computed: {
    },
    methods: {
        handleAction(box) {
            switch (String(box.type)) {
                case 'optimize':
                    if ( box.status === 'optimized' ) {
                        this.$router.push({
                            name: this.$routerName[box.routerName]
                        })
                    } else {
                        this.$emit('open-modal-optimize')
                    }
                break;
                default:
                    this.$router.push({
                        name: this.$routerName[box.routerName]
                    })
                break;
            }
        }
    }
}
</script>
<style lang="scss">
    .quick-action-box {
        padding: 16px;
        width: 358px;
        height: 251px;
        position: relative;
        border: 1px solid #DBE2EB;
        i {
            font-size: 44px;
            color: $primary-color;
        }
        button {
            position: absolute;
            bottom: 16px;
            min-width: 114px;
            .fa-spinner {
                font-size: 14px;
                color: $white-color;
            }
        }
        &.active{
            border-width: 3px;
        }
        &__badge {
            font-size: 12px !important;
            position: absolute;
            right: 16px;
            &.optimized, &.active {
                background: $success-color;
                border-color: $success-color;
            }
            &.inactive, &.optimize, &.new, &.view {
                background: $warning-color;
                border-color: $warning-color;
            }
            &.optimizing {
                background: $disabled-color-dark;
                border-color: $disabled-color-dark;
            }
        }
        // &__new {
        //     border-bottom: 25px solid $primary-color;
        //     border-left: 25px solid transparent;
        //     border-right: 25px solid transparent;
        //     height: 0;
        //     width: 100px;
        //     transform: rotate(45deg);
        //     position: absolute;
        //     top: 13px;
        //     right: -24px;
        //     text-align: center;
        //     &::before {
        //         content: 'NEW';
        //         color: $white-color;
        //         font-weight: 600;
        //     }
        // }
    }
</style>
